import { submit } from 'redux-form'
import { Modal } from '../../components/common'
import { getExamsForRefundSubmissionStatus } from '../../selectors/refundExam'
import { EXAM_SEARCH_FORM_NAME } from '../../constants/RefundExamConstants'

const mapStateToProps = (state, ownProps) => {
  const { modalCloseFocusElem } = ownProps
  const { fetching: submitting } = getExamsForRefundSubmissionStatus(state)

  return {
    submitting,
    modalCloseFocusElem,
  }
}

const ConfirmRefundExamModal = ({ submitting, submit, modalCloseFocusElem, onCloseAction }) => (
  <div>
    <Modal
      shouldCloseModal={submitting}
      modalCloseFocusElem={modalCloseFocusElem}
      onCloseAction={onCloseAction}
      headerTitle="Refund Exams"
      footerActions={[
        { buttonLabel: 'Cancel', isDismissable: true, isPrimary: false },
        {
          buttonLabel: 'Confirm',
          isPrimary: true,
          onClick: () => submit(EXAM_SEARCH_FORM_NAME),
          isDisabled: submitting,
        },
      ]}
    >
      <div>
        <p>Are you sure you want to submit this refund for the selected exam(s)? This action cannot be undone.</p>
      </div>
    </Modal>
  </div>
)

export default connect(mapStateToProps, { submit })(ConfirmRefundExamModal)
